<template>
  <div class="row">
    <!-- Aplicativo -->
    <div class="col-xl-12 col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Configurações da Manutenção</h4>
        </div>
        <div class="card-body">
          <div class="basic-form">
            <div class="col-xl-12">
              <div>
                <div class="form-row">
                  <!-- Distribuir Chamados Automaticamente -->
                  <div class="form-group col-md-5">
                    <h4>Distribuir Chamados Automaticamente?</h4>
                  </div>
                  <div class="form-group col-md-3">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input ponteiro"
                        id="distribuir-chamados"
                        :checked="distribuirChamados"
                        v-model="distribuirChamados"
                      />
                      <label
                        class="custom-control-label ponteiro"
                        for="distribuir-chamados"
                      ></label>
                    </div>
                  </div>
                </div>
                <div v-if="distribuirChamados" class="form-row">
                  <div class="form-group col-md-12">
                    <time-picker
                      :title="'Escolha os intervalos de tempo em que o processo deve funcionar e adicione à lista'"
                      :horarios="horariosDistribuir"
                      :horainicial="'18:00'"
                      :horafinal="'23:59'"
                      v-on:update="updateDistribuir($event)"
                    ></time-picker>
                  </div>
                </div>
                <div class="form-row">
                  <!-- Considerar Vínculo entre Categorias e Ítens -->
                  <div class="form-group col-md-5">
                    <h4>Considerar Vínculo entre Categorias e Ítens?</h4>
                  </div>
                  <div class="form-group col-md-3">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input ponteiro"
                        id="vincular-categoria"
                        :checked="vincularCategoria"
                        v-model="vincularCategoria"
                      />
                      <label
                        class="custom-control-label ponteiro"
                        for="vincular-categoria"
                      ></label>
                    </div>
                  </div>
                </div>
                <div v-if="vincularCategoria" class="form-row">
                  <div class="form-group col-md-12">
                    <time-picker
                      :title="'Horários de funcionamento:'"
                      :horarios="horariosVincular"
                      :horainicial="'18:00'"
                      :horafinal="'23:59'"
                      v-on:update="updateVincular($event)"
                    ></time-picker>
                  </div>
                </div>
                <!-- Tabela de Categorias -->
                <div class="mt-4">
                  <h4>Categorias</h4>
                  <table class="table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Categoria</th>
                        <th>Manutenção</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                       v-for="categoria in paginatedCategorias"
                        :key="categoria.idcategoriaprod"
                      >
                        <td>{{ categoria.idcategoriaprod }}</td>
                        <td>{{ categoria.desccategoriaprod }}</td>
                        <td>
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              class="custom-control-input ponteiro"
                              :id="'manutencao-' + categoria.idcategoriaprod"
                              v-model="categoria.manutencao"
															@change="atualizarCategoria(categoria)"
                            />
                            <label
                              class="custom-control-label ponteiro"
                              :for="'manutencao-' + categoria.idcategoriaprod"
                            ></label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <nav aria-label="Page navigation">
                    <ul class="pagination">
                      <li
                        class="page-item"
                        :class="{ disabled: currentPage === 1 }"
                      >
                        <a class="page-link" href="#" @click.prevent="prevPage"
                          >Anterior</a
                        >
                      </li>
                      <li
                        class="page-item"
                        v-for="page in totalPages"
                        :key="page"
                        :class="{ active: currentPage === page }"
                      >
                        <a
                          class="page-link"
                          href="#"
                          @click.prevent="goToPage(page)"
                          >{{ page }}</a
                        >
                      </li>
                      <li
                        class="page-item"
                        :class="{ disabled: currentPage === totalPages }"
                      >
                        <a class="page-link" href="#" @click.prevent="nextPage"
                          >Próxima</a
                        >
                      </li>
                    </ul>
                  </nav>
                </div>
                <div class="mb-4">
                  <button
                    @click="atualizarDistribuicao()"
                    type="button"
                    class="btn btn-primary mt-4"
                    id="toastr-danger-top-right"
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from "../constants";
import axios from "axios";
import TimePicker from "./TimePicker.vue";

export default {
  components: {
    TimePicker,
  },
  data() {
    return {
      site: "",
      categorias: [
      ],
      headers: {
        "x-access-token": this.$store.getters.GetLoginInfo.token,
      },
      dadoshotel: {},
      menus: [],
      menuselecionado: [],
      paises: [],
      ufs: [],
      cidades: [],
      imgTermoSrc: null,
      imgLGPDSrc: null,
      noDataTextLGPD: "Carregando documento...",
      noDataTextTermo: "Carregando documento...",
      novoHotelSobre: {
        idhotelsobre: 0,
        idioma: this.$i18n.locale,
        titulo: "",
        subtitulo: "",
        texto: "",
        ativo: false,
      },
      novoCidadeSobre: {
        idcidadesobre: 0,
        idioma: this.$i18n.locale,
        titulo: "",
        subtitulo: "",
        texto: "",
        rodape: "",
        ativo: false,
      },
      hotelSobreItens: [],
      cidadeSobreItens: [],
      importarTabelas: false,
      integracoes: [
        { id: 1, descricao: "Totvs" },
        { id: 2, descricao: "Hits" },
      ],
      idIntegracao: 1,
      sounds: CONSTANTS.SOUNDS,
      editedTipo: {},
      editedItem: {},
      displayWizard: false,
      step: 0,
      distribuirChamados: true,
      vincularCategoria: true,
      horariosDistribuir: "18:00-23:59; 00:00-06:00; ",
      horariosVincular: "18:00-23:59; 00:00-06:00; ",
			currentPage: 1,
			itemsPerPage: 5
    };
  },
  methods: {
		atualizarCategoria(categoria) {
			console.log(categoria)
			var params = {
        config: categoria.manutencao,
				id: categoria.idcategoriaprod
      };
      axios
        .post(CONSTANTS.API_URL + "/fdguest/estoque/categorias/config/atualizar", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            console.log('categoria salva')
          }
        })
        .catch((e) => {
          this.$snackE(`Erro ao salvar a configuração: ${JSON.stringify(e)}`);
        });
		},
		prevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
			}
		},
		nextPage() {
			if (this.currentPage < this.totalPages) {
				this.currentPage++;
			}
		},
		goToPage(page) {
			this.currentPage = page;
		},	
    updateDistribuir(evt) {
      this.horariosDistribuir = evt;
    },
    updateVincular(evt) {
      this.horariosVincular = evt;
    },
    atualizarDistribuicao() {
      var params = {
        distribuirChamados: this.distribuirChamados,
        vincularCategoria: this.vincularCategoria,
        horariosDistribuir: this.horariosDistribuir,
        horariosVincular: this.horariosVincular,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      axios
        .post(CONSTANTS.API_URL + "/fdguest/sistema/update", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.closeAccordionItem(
              "distribuicao-accordion-item",
              "distribuicao-chamados"
            );
            this.$snack("Configuração salva com sucesso!");
          }
        })
        .catch((e) => {
          this.$snackE(`Erro ao salvar a configuração: ${JSON.stringify(e)}`);
        });
    },
    updateList() {
      //window.location.reload();
      console.error("atualizar lista...");
    },
    showWizard(data) {
      this.editedTipo = data.tipo;
      this.editedItem = data.item;
      this.step = data.step;
      this.displayWizard = true;
    },
    playSound() {
      //var snd = new Audio("data:audio/wav;base64,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");
      var index = this.dadoshotel.somalerta;
      index = index ? index : 0;
      var snd = new Audio(this.sounds[index]["value"]);
      snd.play();
    },
    criarCidadeSobre() {
      var obj = document.getElementById("criarCidadeSobreDiv");
      if (obj) {
        obj.style.display = "block";
      }
    },
    fecharCriarCidadeSobre() {
      var obj = document.getElementById("criarCidadeSobreDiv");
      if (obj) {
        obj.style.display = "none";
      }
    },
    salvarNovoCidadeSobre(item) {
      var params = {
        idhotel: this.$store.getters.GetLoginInfo.idhotel,
        titulo: item.titulo,
        subtitulo: item.subtitulo,
        texto: item.texto,
        rodape: item.rodape,
        ativo: item.ativo,
        criado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      //console.error(JSON.stringify(params))
      axios
        .post(CONSTANTS.API_URL + "/fdguest/cidadesobre/insert", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.carregarCidadeSobreItens();
            this.fecharCriarCidadeSobre();
          } else {
            console.log("Erro: " + response.status);
          }
        });
    },
    carregarCidadeSobreItens() {
      var params = {
        idioma: this.$i18n.locale,
        idhotel: this.$store.getters.GetLoginInfo.idhotel,
      };
      axios
        .post(CONSTANTS.API_URL + "/fdguest/cidadesobre/select", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.cidadeSobreItens = response.data;
          }
        });
    },
    editarCidadeSobre(item) {
      var obj = document.getElementById(
        "EditarCidadeSobre_" + item.idcidadesobre
      );
      if (obj) {
        obj.style.display = "block";
      }
    },
    fecharEditarCidadeSobre(item) {
      var obj = document.getElementById(
        "EditarCidadeSobre_" + item.idcidadesobre
      );
      if (obj) {
        obj.style.display = "none";
      }
    },
    editarHotel(item) {
      var obj = document.getElementById("EditarHotel_" + item.idhotel);
      if (obj) {
        obj.style.display = "block";
      }
    },
    salvarCidadeSobre(item) {
      var params = {
        idcidadesobre: item.idcidadesobre,
        idhotel: this.$store.getters.GetLoginInfo.idhotel,
        titulo: item.titulo,
        subtitulo: item.subtitulo,
        texto: item.texto,
        rodape: item.rodape,
        ativo: item.ativo,
        idioma: item.idioma,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      console.log(JSON.stringify(params));
      axios
        .post(CONSTANTS.API_URL + "/fdguest/cidadesobre/update", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.carregarCidadeSobreItens();
            this.fecharEditarCidadeSobre(item);
            return true;
          } else {
            console.log("Erro: " + response.status);
            return false;
          }
        });
    },
    ativarCidadeSobre(item, ativo) {
      var itemAtivar = {
        idcidadesobre: item.idcidadesobre,
        ativo: ativo,
      };
      if (this.salvarCidadeSobre(itemAtivar)) {
        item.ativo = ativo;
      }
    },
    criarHotelSobre() {
      var obj = document.getElementById("criarSobreDiv");
      if (obj) {
        obj.style.display = "block";
      }
    },
    closeNew() {
      var obj = document.getElementById("criarSobreDiv");
      if (obj) {
        obj.style.display = "none";
      }
    },
    saveNew(item) {
      var params = {
        idhotel: this.$store.getters.GetLoginInfo.idhotel,
        titulo: item.titulo,
        subtitulo: item.subtitulo,
        texto: item.texto,
        ativo: true,
        criado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      axios
        .post(CONSTANTS.API_URL + "/fdguest/hotelsobre/insert", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.loadHotelSobreItens();
            this.closeNew();
          } else {
            console.log("Erro: " + response.status);
          }
        });
    },
    editar(item) {
      var obj = document.getElementById("Editar_" + item.idhotelsobre);
      if (obj) {
        obj.style.display = "block";
      }
    },
    closeEdit(item) {
      var obj = document.getElementById("Editar_" + item.idhotelsobre);
      if (obj) {
        obj.style.display = "none";
      }
    },
    saveEdit(item) {
      var params = {
        idhotelsobre: item.idhotelsobre,
        idhotel: this.$store.getters.GetLoginInfo.idhotel,
        titulo: item.titulo,
        subtitulo: item.subtitulo,
        texto: item.texto,
        ativo: item.ativo,
        idioma: item.idioma,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      //console.log(JSON.stringify(params))
      axios
        .post(CONSTANTS.API_URL + "/fdguest/hotelsobre/update", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.loadHotelSobreItens();
            this.closeEdit(item);
            return true;
          } else {
            console.log("Erro: " + response.status);
            return false;
          }
        });
    },
    ativar(item, ativo) {
      var itemAtivar = {
        idhotelsobre: item.idhotelsobre,
        ativo: ativo,
      };
      if (this.saveEdit(itemAtivar)) {
        item.ativo = ativo;
      }
    },
    loadHotelSobreItens() {
      var params = {
        idioma: this.$i18n.locale,
        idhotel: this.$store.getters.GetLoginInfo.idhotel,
      };
      axios
        .post(CONSTANTS.API_URL + "/fdguest/hotelsobre/select", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.hotelSobreItens = response.data;
          }
        });
    },
    baixar(campo) {
      var titulo = "";
      var dados = "";
      if (campo == "termoservico") {
        titulo = this.dadoshotel.nometermoservico;
        dados = this.imgTermoSrc;
      } else {
        titulo = this.dadoshotel.nometermolgpd;
        dados = this.imgLGPDSrc;
      }
      var dlink = document.createElement("a");
      dlink.style.display = "none";
      dlink.setAttribute("download", titulo);
      dlink.setAttribute("href", dados);
      document.body.appendChild(dlink);
      dlink.click();
    },
    salvarImagem(tipo, filename, src, nomecampo) {
      if (nomecampo == "termoservico") {
        this.imgTermoSrc = src;
      } else {
        this.imgLGPDSrc = src;
      }
      var params = {
        tipo: tipo,
        nome: filename,
        dados: src,
        tabela: "hotel",
        fk: nomecampo,
        chave: "idhotel",
        valor: this.$store.getters.GetLoginInfo.idhotel,
        idusuario: this.$store.getters.GetLoginInfo.idusuario,
        salvararquivo: false,
      };
      axios
        .post(CONSTANTS.API_URL + "/fdguest/imagem/upinsert", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            //alert('Cadastro realizado com sucesso')
            if (nomecampo == "termoservico") {
              this.dadoshotel.termoservico = response.data.result.imagem;
            } else {
              this.dadoshotel.termolgpd = response.data.result.imagem;
            }
          } else {
            console.log(response);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    onTermoChange() {
      //Read File
      var selectedFile = document.getElementById("termoFile").files;
      //Check File is not Empty
      if (selectedFile.length > 0) {
        // Select the very first file from list
        var fileToLoad = selectedFile[0];
        // FileReader function for read the file.
        var fileReader = new FileReader();
        // Isso é necessário pois 'this' não é acessível na função de callback abaixo
        var fn = this.salvarImagem;
        // Ao final da leitura do arquivo salvar o pdf...
        fileReader.onload = function (fileLoadedEvent) {
          fn(
            "application/pdf",
            fileToLoad.name,
            fileLoadedEvent.target.result,
            "termoservico"
          );
        };
        // Ler o arquivo e converter para base64
        fileReader.readAsDataURL(fileToLoad);
      }
    },
    onLGPDChange() {
      //Read File
      var selectedFile = document.getElementById("lgpdFile").files;
      //Check File is not Empty
      if (selectedFile.length > 0) {
        // Select the very first file from list
        var fileToLoad = selectedFile[0];
        // FileReader function for read the file.
        var fileReader = new FileReader();
        // Isso é necessário pois 'this' não é acessível na função de callback abaixo
        var fn = this.salvarImagem;
        // Onload of file read the file content
        fileReader.onload = function (fileLoadedEvent) {
          fn(
            "application/pdf",
            fileToLoad.name,
            fileLoadedEvent.target.result,
            "termolgpd"
          );
        };
        // Convert data to base64
        fileReader.readAsDataURL(fileToLoad);
      }
    },
    carregarImagemTermo(id) {
      //console.error({id:id})
      this.imgTermoSrc = null;
      this.noDataTextTermo = "Carregando termos do serviço...";
      axios
        .post(
          CONSTANTS.API_URL + "/fdguest/imagem/select",
          { id: id },
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            var imgObj = response.data[0];
            if (imgObj) {
              this.imgTermoSrc = Buffer.from(imgObj.dados).toString();
            } else {
              this.noDataTextTermo =
                "Nenhum arquivo, clique em Escolher Arquivo.";
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    carregarImagemLGPD(id) {
      this.imgLGPDSrc = null;
      this.noDataTextLGPD = "Carregando termo de LGPD...";
      axios
        .post(
          CONSTANTS.API_URL + "/fdguest/imagem/select",
          { id: id },
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            var imgObj = response.data[0];
            if (imgObj) {
              this.imgLGPDSrc = Buffer.from(imgObj.dados).toString();
            } else {
              this.noDataTextLGPD =
                "Nenhum arquivo, clique em Escolher Arquivo.";
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    async salvarHotel(hotel) {
      var params = {
        idhotel: hotel.idhotel,
        nome: hotel.nome,
        telefone: hotel.telefone,
        pais: hotel.idpais,
        cep: hotel.cep,
        codigoibge: hotel.cidadecodigoibge,
        bairro: hotel.bairro,
        endereco: hotel.endereco,
        numero: hotel.numero,
        complemento: hotel.complemento,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      await axios
        .put(CONSTANTS.API_URL + "/fdguest/hotel/update", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.fecharEditarHotel();
            console.log("Cadastro realizado com sucesso");
          } else {
            console.log(response);
          }
        });
    },
    fecharEditarHotel() {
      this.closeAccordionItem("dados-hotel-item", "dados-hotel-content");
    },
    salvarItemMenu(item) {
      item.ativo = !item.ativo;
      var params = {
        idmenu: item.idmenu,
        ativo: item.ativo,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      axios
        .put(CONSTANTS.API_URL + "/fdguest/menu/update", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            //alert('Cadastro realizado com sucesso')
          }
        });
    },
    closeAccordionItem(idbar, idcontent) {
      var el1 = document.getElementById(idbar);
      var el2 = document.getElementById(idcontent);
      if (el1 && el2) {
        if (!el1.classList.contains("collapsed")) {
          el1.classList.add("collapsed");
        }
        if (el2.classList.contains("show")) {
          el2.classList.remove("show");
        }
      }
    },
    atualizarIntegracao() {
      var params = {
        idhotel: this.dadoshotel.idhotel,
        idpdvintegrado: this.dadoshotel.idpdvintegrado,
        idpdvlavanderia: this.dadoshotel.idpdvlavanderia,
        idhotelpms: this.dadoshotel.idhotelpms,
        idsfamilia: this.dadoshotel.idsfamilia,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      if (this.importarTabelas) {
        params.dataultimaimportacao = null;
        this.importarTabelas = false;
      }
      axios
        .put(CONSTANTS.API_URL + "/fdguest/hotel/update", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            let params = {
              idIntegracao: this.idIntegracao,
              alterado_por: this.$store.getters.GetLoginInfo.idusuario,
            };
            axios
              .post(CONSTANTS.API_URL + "/fdguest/sistema/update", params, {
                headers: this.headers,
              })
              .then((another) => {
                if (another.status == 200) {
                  this.closeAccordionItem(
                    "integracao-accordion-item",
                    "integracao-outros-sistemas"
                  );
                  console.log("Cadastro realizado com sucesso");
                }
              });
          }
        });
    },
    enviarAntecedencia() {
      var antecedencia = {
        idhotel: this.dadoshotel.idhotel,
        antecedencia: this.dadoshotel.antecedencia,
        somalerta: this.dadoshotel.somalerta,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      axios
        .put(CONSTANTS.API_URL + "/fdguest/hotel/update", antecedencia, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            var obj = { ...this.$store.getters.GetLoginInfo };
            obj.hotel.somalerta = this.dadoshotel.somalerta;
            this.$store.dispatch("set_Login_Info", obj);
            this.closeAccordionItem(
              "recepcao-config",
              "recepcao-config-content"
            );
            console.log("Cadastro realizado com sucesso");
          }
        });
    },
    enviarSite() {
      var site = {
        idhotel: this.dadoshotel.idhotel,
        idusuariocadastro: this.$store.getters.GetLoginInfo.idusuario,
        site: this.dadoshotel.site,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      //console.error(JSON.stringify(site))
      axios
        .put(CONSTANTS.API_URL + "/fdguest/hotel/update", site, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.closeAccordionItem(
              "link-website-item",
              "link-website-content"
            );
            console.log("Cadastro realizado com sucesso");
          }
        });
    },
    enviarReservas() {
      var site = {
        idhotel: this.dadoshotel.idhotel,
        idusuariocadastro: this.$store.getters.GetLoginInfo.idusuario,
        telefonereserva: this.dadoshotel.telefonereserva,
        whatsapp: this.dadoshotel.whatsapp,
        emailreserva: this.dadoshotel.emailreserva,
        nome: this.dadoshotel.nome,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      axios
        .put(CONSTANTS.API_URL + "/fdguest/hotel/update", site, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.closeAccordionItem("reservas-item", "reservas-content");
            console.log("Cadastro realizado com sucesso");
          }
        });
    },
    enviarHorarios() {
      var horarios = {
        idhotel: this.dadoshotel.idhotel,
        limpezahorarioinicial: this.dadoshotel.limpezahorarioinicial,
        limpezahorariofinal: this.dadoshotel.limpezahorariofinal,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      axios
        .put(CONSTANTS.API_URL + "/fdguest/hotel/update", horarios, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            alert("Cadastro realizado com sucesso");
          }
        });
    },
    // enviarMenuDigital() {
    // 	var site = {
    // 		idusuariocadastro: this.$store.getters.GetLoginInfo.idusuario,
    // 		idhotel: this.dadoshotel.idhotel,
    // 		sitemenudigital: this.dadoshotel.sitemenudigital
    // 	}
    // 	axios.put(CONSTANTS.API_URL + '/fdguest/hotel/update',
    // 	site, {headers: this.headers}).then(response =>{
    // 		if(response.status == 200) {
    // 			alert('Cadastro realizado com sucesso')
    // 		}
    // 	})
    // },
    enviarDados() {
      var site = {
        nome: this.nomehotel,
        telefone: this.telhotel,
        cidade: this.cidadehotel,
        bairro: this.bairrohotel,
        idhotel: this.dadoshotel.idhotel,
        ativo: this.dadoshotel.ativo,
        razaosocial: this.dadoshotel.razaosocial,
        cnpj: this.dadoshotel.cnpj,
        alterado_por: this.$store.getters.GetLoginInfo.idusuario,
      };
      axios
        .put(CONSTANTS.API_URL + "/fdguest/hotel/update", site, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            alert("Cadastro realizado com sucesso");
          }
        });
    },
    loadMenuItens() {
      axios
        .post(
          CONSTANTS.API_URL + "/fdguest/menu/select",
          {
            idhotel: this.$store.getters.GetLoginInfo.idhotel,
            idpai: CONSTANTS.GUEST_ROOT,
            idioma: this.$i18n.locale,
          },
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            this.menus = response.data;
          }
        });
    },
    loadConfig() {
      axios
        .post(
          CONSTANTS.API_URL + "/fdguest/sistema/select",
          {
            idioma: this.$i18n.locale,
          },
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            let cfg = response.data;
            this.idIntegracao = cfg.idIntegracao;
            this.distribuirChamados = cfg.distribuirChamados == "true";
            this.horariosDistribuir = cfg.horariosDistribuir;
            this.vincularCategoria = cfg.vincularCategoria == "true";
            this.horariosVincular = cfg.horariosVincular;
          }
        });
    },
		loadCategorias() {
      axios
        .post(
          CONSTANTS.API_URL + "/fdguest/estoque/categorias/config",
          {
            idioma: this.$i18n.locale,
          },
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
						console.log('buscou caregorias >>>>>>>>>')
            this.categorias = response.data;
          }
        });
    },
    loadPaises() {
      axios
        .post(
          CONSTANTS.API_URL + "/fdguest/pais/select",
          {
            idioma: this.$i18n.locale,
          },
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            this.paises = response.data;
          }
        });
    },
    loadUFS() {
      axios
        .post(
          CONSTANTS.API_URL + "/fdguest/uf/select",
          {
            idioma: this.$i18n.locale,
          },
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            this.ufs = response.data;
          }
        });
    },
    carregarHotel(id) {
      axios
        .post(
          CONSTANTS.API_URL + "/fdguest/hotel/select",
          {
            idioma: this.$i18n.locale,
            idhotel: id,
          },
          { headers: this.headers }
        )
        .then((response) => {
          if (response.status == 200) {
            if (response.data.length > 0) {
              this.dadoshotel = response.data[0];
              this.loadCidades();
              this.carregarImagemTermo(this.dadoshotel.termoservico);
              this.carregarImagemLGPD(this.dadoshotel.termolgpd);
              this.loadHotelSobreItens();
              this.carregarCidadeSobreItens();
            }
          }
        });
    },
    loadCidades() {
      var params = {
        idioma: this.$i18n.locale,
        codigoufibge: this.dadoshotel.ufcodigoibge,
      };
      axios
        .post(CONSTANTS.API_URL + "/fdguest/cidade/select", params, {
          headers: this.headers,
        })
        .then((response) => {
          if (response.status == 200) {
            this.cidades = response.data;
          }
        });
    },
  },
  computed: {
		totalPages() {
			return Math.ceil(this.categorias.length / this.itemsPerPage);
		},
		paginatedCategorias() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const end = start + this.itemsPerPage;
			return this.categorias.slice(start, end);
		},
    antecedenciaValida() {
      var x = 0;
      try {
        x = parseInt(this.dadoshotel.antecedencia);
      } catch (e) {
        x = -1;
      }
      return x > 0;
    },
    validTimes() {
      var horarioInicial = this.dadoshotel
        ? this.dadoshotel.limpezahorarioinicial
        : "11:00";
      var horarioFinal = this.dadoshotel
        ? this.dadoshotel.limpezahorariofinal
        : "16:00";
      if (horarioInicial && horarioFinal) {
        var aStr = horarioInicial.replace(/[:]/g, "");
        var a = parseInt(aStr);
        var bStr = horarioFinal.replace(/[:]/g, "");
        var b = parseInt(bStr);
        return a <= b;
      } else {
        return true;
      }
    },
  },
  created() {
    this.carregarHotel(this.$store.getters.GetLoginInfo.idhotel);
  },
  mounted() {
		this.loadCategorias();
    this.loadConfig();
    this.loadPaises();
    this.loadUFS();
    //this.carregarHotel(this.$store.getters.GetLoginInfo.idhotel)
    this.loadMenuItens();
  },
};
</script>

<style>
.carregando {
  padding: 3rem;
  padding-top: 5.7rem;
  padding-bottom: 5.7rem;
  color: orange;
  font-weight: bold;
}
</style>
